var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 43.7 43.7",
    style: {
      enableBackground: "new 0 0 43.7 43.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#333366;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "USPS_x5F_Blue_x5F_295C"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.8,43.7C9.8,43.7,0,33.9,0,21.8S9.8,0,21.8,0s21.9,9.8,21.9,21.8C43.7,33.9,33.9,43.7,21.8,43.7z  M21.8,4.2c-9.7,0-17.6,7.9-17.6,17.6s7.9,17.6,17.6,17.6c9.7,0,17.6-7.9,17.6-17.6S31.5,4.2,21.8,4.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.2,30.8l3.7-13.2l-4.6,0.2L17,20.5v0.9l1-0.2c0.8-0.1,1.3-0.2,1.4-0.2c0.1,0,0.1,0,0.1,0 c-0.1,0.2-0.2,1-0.5,2l-2.2,7.5c-0.3,1-0.5,1.7-0.5,2.3s0.3,1.3,0.7,1.7c0.5,0.4,1.1,0.7,1.7,0.7h0.1c1,0,1.9-0.4,2.7-1.1 c1.1-0.9,2.1-1.9,2.9-3.2l0.5-0.7c0,0-4.2,1.9-3.8,0.9C21.2,31.1,21.2,31,21.2,30.8z M23.4,9.2c-1.7,0-3.1,1.4-3.1,3.1 c0,1.7,1.4,3.1,3.1,3.1s3.1-1.4,3.1-3.1C26.4,10.6,25,9.2,23.4,9.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.1c2fd80102338ce12e933f47b9def072.svg";
export { ForwardRef as ReactComponent };